import { Component } from 'react'
import ConnectButton from '../../components/ConnectButton'
import { saveDemandbaseApiKey } from 'app/modules/integrations/api'
import withNotifications from 'components/shared/notifications'
import ConditionalRender from 'components/shared/ConditionalRender'
import PropTypes from 'prop-types'
import style from './style'

const SUCCESS_MESSAGE = 'Demandbase was successfully connected!'
const ERROR_MESSAGE = 'Oops, there was an error. Please try again.'

class Demandbase extends Component {

  static contextTypes = {
    app: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      apiKey: '',
      isConnecting: false,
      isConnected: props.isConnected
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ isConnected: props.isConnected })
  }

  onApiKeyChanged = (event) => {
    this.setState({ apiKey: event.target.value })
  }

  isApiKeyValid = () => {
    return this.state.apiKey !== ''
  }

  isConnectButtonDisabled = () => {
    return !this.isApiKeyValid()
  }

  connectIntegration = () => {
    const { notifications } = this.props
    const { IntegrationsQueries } = this.context.app.queries

    const connect = () => {
      saveDemandbaseApiKey(this.state.apiKey)
        .then(() => notifications.success(SUCCESS_MESSAGE))
        .catch(() => notifications.error(ERROR_MESSAGE))
        .then(() => this.setState({ isConnecting: false, isConnected: true }))
        .then(() => IntegrationsQueries.fetchIntegrationStates())
    }

    this.setState({ isConnecting: true }, connect)
  }

  render() {
    const { isConnecting, isConnected } = this.state

    return (
      <div className="demandbase-integration-page">
        <p className="integration-page-description">
          Enrich your lead data further in Drift by enabling the Demandbase integration.
          We’ll attach information such as company name, headquarters location,
          and company size to leads when they become identified in Drift by email.
          <a href="https://help.drift.com/integrations/demandbase-integration" target="_blank">
            Learn More
          </a>
        </p>
        <div className="drift-form">
          <ConditionalRender condition={!isConnected}>
            <span className="demandbase-key-label">
              API key
            </span>
            <input
              className="demandbase-key-input"
              type="text"
              placeholder="e.g. 123456"
              onChange={this.onApiKeyChanged}
            />
            <p className="demandbase-key-description">
              Use your Demandbase API Key to connect Demandbase and Drift
            </p>
          </ConditionalRender>
        </div>
        <ConditionalRender condition={!isConnected}>
          <ConnectButton
            disabled={this.isConnectButtonDisabled()}
            onClick={this.connectIntegration}
            isProcessing={isConnecting}
          />
        </ConditionalRender>
      </div>
    )
  }
}

export default withNotifications(Demandbase)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Demandbase/index.js